import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { AUTH_ROUTES } from '@/lib/constants';
import { isClientRole } from '@/lib/rbac';
import { useAuthStore } from '@/stores/authStore';

export const Route = createFileRoute('/_client-fullscreen')({
  beforeLoad: ({ location }) => {
    const { isAuthenticated, user } = useAuthStore.getState();
    if (!isAuthenticated || !user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: AUTH_ROUTES.CLIENT_LOGIN,
        search: { redirect: location.href } as never,
      });
    }
    if (!isClientRole(user.role)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: AUTH_ROUTES.CLIENT_LOGIN });
    }
  },
  component: ClientFullscreenLayout,
});

function ClientFullscreenLayout() {
  return <Outlet />;
}
